<script setup lang="ts">
import { toRefs } from 'vue';
import { cn } from '@pkg/ui/lib/utils';
import { baseTextVariants } from './';

interface Props {
  variant?: NonNullable<Parameters<typeof baseTextVariants>[0]>['variant'];
}

const props = defineProps<Props>();
const { variant } = toRefs(props);

</script>

<template>
  <p
    :class="cn(baseTextVariants({ variant }), $attrs.class ?? '')"
  >
    <slot />
  </p>
</template>

<style scoped>
.c-base-text {
  &--center {
    text-align: center;
  }
}
</style>
